import React, { useState } from "react";
import { useSelector,useDispatch } from "react-redux";
import { Form, Row, Col } from "react-bootstrap";

import ButtonStandard from "../../components/ButtonStandard/ButtonStandard"
import messages from "../../assets/i18n";
import txWeekDays from '../../helpers/txWeekDays'
import formatHourApi from '../../helpers/formatHourApi'
import formatHourDisplay from '../../helpers/formatHourDisplay'
import { convertArrHourToStrHour } from '../../helpers/convertHour'

function CdHour(props) {
	const dispatch = useDispatch();
	const lang = useSelector(state => state.language.name);

	const [hours, setHours] = useState(props.hours);

	const resetHoursFunc = (hour, i) => {
		let newHours = [...hours];
		const arrHour = hour.hrInicial.split(':');
		arrHour[0] = parseInt(arrHour[0], 10) + 1;
		newHours[i].hrInicial = hour.hrInicial;
		newHours[i].hrFim = isHoursDisable(hour) ? convertArrHourToStrHour(arrHour) : hour.hrInicial;
		setHours(newHours)
	}

	const isHoursDisable = hour => (hour.hrInicial === hour.hrFim)

	const handleInputHour = (hours, i, typeHour) => (e) => {
		let newHour = [ ...hours ];
		let value = parseInt(e.target.value);
		
		if(typeHour === 'capacidade'){
			if(isNaN(value) || value < parseInt(e.target.min) || value > parseInt(e.target.max)){
				dispatch({
					type: "SET_CD_GATE_VALID_CAPACIDADE_FORM",
					valid: false
				});
			} else {
				dispatch({
					type: "SET_CD_GATE_VALID_CAPACIDADE_FORM",
					valid: true
				});
			}
			newHour[i][typeHour] = e.target.value;
		} else if(typeHour === 'carga') {
			if(isNaN(value) || value < parseInt(e.target.min) || value > parseInt(e.target.max)){
				dispatch({
					type: "SET_CD_GATE_VALID_CARGA_FORM",
					valid: false
				});
			} else {
				dispatch({
					type: "SET_CD_GATE_VALID_CARGA_FORM",
					valid: true
				});
			}
			newHour[i][typeHour] = e.target.value;		
		} else {
			if(typeHour === 'intervalo') {
				if(isNaN(value) || value < parseInt(e.target.min) || value > parseInt(e.target.max)){
					dispatch({
						type: "SET_CD_GATE_VALID_INTERVALO_FORM",
						valid: false
					});
				} else {
					dispatch({
						type: "SET_CD_GATE_VALID_INTERVALO_FORM",
						valid: true
					});
				}
				newHour[i][typeHour] = e.target.value;
			} else{
				newHour[i][typeHour] = formatHourApi(e.target.value);
			}
		}
		setHours(newHour);
	}
	
	const { hour, indice} = props

	return (
		<Col key={hour.id} className="pl-0">
			<Col className="extra-rounded-bottom border px-0 pb-3 pt-2">
				<Row>
					<Col>
            <span className="text-4 text-uppercase">{
              messages[lang][txWeekDays(hour.idDiaSemana)]
            }</span>
					</Col>
				</Row>
				<Row>
					<Col xs={6} className="text-left pl-4">
					<p className="mb-0 text-2 pl-1 text-color-grey">{messages[lang].open}</p>
						<input
							type="time"
							className="input-time"
							id={"cd-hours-inicial-hour" + hour.id}
							disabled={isHoursDisable(hour)}
							value={formatHourDisplay(hour.hrInicial)}
							onChange={
								handleInputHour(hours, indice, "hrInicial")
							}
						/>
					</Col>
					<Col xs={6} className="text-left">
						<p className="mb-0 text-2 pl-1 text-color-grey">{messages[lang].close}</p>
						<input
							type="time"
							className="input-time"
							id={"cd-hours-final-hour" + hour.id}
							disabled={isHoursDisable(hour)}
							value={formatHourDisplay(hour.hrFim)}
							onChange={
								handleInputHour(hours, indice, "hrFim")
							}
						/>
					</Col>
				</Row>
				
				{(props.type === 'gate') ? 
					<>
						<hr />
						<Row>
							<Col xs={12} className="text-left">
								<Form.Group bsPrefix={"form-group-cdhour"}>
									<Form.Label>{messages[lang].load}:</Form.Label>
									<Form.Control 
										type="number" 
										onChange={ handleInputHour(hours, indice, "carga") }
										placeholder="1"
										value={props.dynamicCapacity ? hour.carga : 1}
										min={1}
										max={1000000}
										required={true} 
										disabled={!props.dynamicCapacity}
									/>
								</Form.Group>
							</Col>
							<Col xs={12} className="text-left">
								<Form.Group bsPrefix={"form-group-cdhour"}>
									<Form.Label>{messages[lang].capacity}:</Form.Label>
									<Form.Control 
										type="number" 
										onChange={ handleInputHour(hours, indice, "capacidade") }
										placeholder="0"
										value={hour.capacidade}
										min={0}
										max={1000000}
										required={true} 
										disabled={isHoursDisable(hour)}
									/>
								</Form.Group>
							</Col>
							<Col xs={12} className="text-left">
								<Form.Group bsPrefix={"form-group-cdhour"}>
									<Form.Label>{messages[lang].interval}:</Form.Label>
									<Form.Control 
										type="number" 
										onChange={ handleInputHour(hours, indice, "intervalo") }
										placeholder="1" 
										value={hour.intervalo}
										min={1} 
										max={24}
										required={true} 
										disabled={isHoursDisable(hour)}
									/>
								</Form.Group>
							</Col>
						</Row>
					</> 
				: 
					<></>
				}
				{!(props.action && props.action === 'create') ? 
					<> 
						<Row >
							<Col className="pt-3">
								<ButtonStandard
									id={"load_remove_orders_button" + hour.id}
									text={isHoursDisable(hour) ? messages[lang].enabled : messages[lang].disabled }
									textClass="text-1"
									className={
										isHoursDisable(hour)
											? "btn-sm btn-outline-primary btn-standard px-2" 
											: "btn-sm btn-outline-primary btn-standard px-2"
										}
									onClick={() => resetHoursFunc(hours[indice], indice)}
								/>
							</Col>
						</Row> 
					</>
				: 
					<></>
				}
			</Col>
		</Col>
	)
}

export default CdHour;